export const exams = [
  {
    courseCode: 'BBA101',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-21'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'BBA102',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-22'),
    examType: 'Finals',
    examStartTime: '12:00',
    examEndTime: '14:00',
  },
  {
    courseCode: 'BBA201',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-23'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'BBA202',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-24'),
    examType: 'Finals',
    examStartTime: '15:00',
    examEndTime: '17:00',
  },
  {
    courseCode: 'BBA301',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-25'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'BBA302',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-26'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },

  {
    courseCode: 'EE101',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-27'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'EE102',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-28'),
    examType: 'Finals',
    examStartTime: '12:00',
    examEndTime: '14:00',
  },
  {
    courseCode: 'EE201',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-29'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'EE202',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-30'),
    examType: 'Finals',
    examStartTime: '14:00',
    examEndTime: '16:00',
  },
  {
    courseCode: 'EE301',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-01'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'EE302',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-02'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },

  {
    courseCode: 'ME101',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-03'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'ME102',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-04'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'ME201',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-05'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'ME202',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-06'),
    examType: 'Finals',
    examStartTime: '15:00',
    examEndTime: '17:00',
  },
  {
    courseCode: 'ME301',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-07'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'ME302',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-08'),
    examType: 'Finals',
    examStartTime: '14:00',
    examEndTime: '16:00',
  },

  {
    courseCode: 'SE101',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-09'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'SE102',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-10'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'SE201',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-11'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'SE202',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-12'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'SE301',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-13'),
    examType: 'Finals',
    examStartTime: '11:00',
    examEndTime: '13:00',
  },
  {
    courseCode: 'SE302',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-14'),
    examType: 'Finals',
    examStartTime: '14:00',
    examEndTime: '16:00',
  },
  {
    courseCode: 'SE401',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-15'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'SE402',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-16'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },

  {
    courseCode: 'CE101',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-17'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'CE102',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-18'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'CE201',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-19'),
    examType: 'Finals',
    examStartTime: '11:00',
    examEndTime: '13:00',
  },
  {
    courseCode: 'CE202',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-20'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'CE301',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-21'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'CE302',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-22'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'CE401',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-23'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'CE402',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-24'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'CE403',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-25'),
    examType: 'Finals',
    examStartTime: '11:00',
    examEndTime: '13:00',
  },
  {
    courseCode: 'CE404',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-26'),
    examType: 'Finals',
    examStartTime: '14:00',
    examEndTime: '16:00',
  },
  {
    courseCode: 'CS101',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-21'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'CS102',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-22'),
    examType: 'Finals',
    examStartTime: '12:00',
    examEndTime: '14:00',
  },
  {
    courseCode: 'CS201',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-23'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'CS202',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-24'),
    examType: 'Finals',
    examStartTime: '15:00',
    examEndTime: '17:00',
  },
  {
    courseCode: 'CS301',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-25'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'CS302',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-26'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'CS303',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-27'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'CS304',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-28'),
    examType: 'Finals',
    examStartTime: '12:00',
    examEndTime: '14:00',
  },
  {
    courseCode: 'CS401',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-29'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'CS402',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-11-30'),
    examType: 'Finals',
    examStartTime: '14:00',
    examEndTime: '16:00',
  },
  {
    courseCode: 'CS403',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-01'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'CS404',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-02'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'CS405',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-03'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'CS406',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-04'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'CS407',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-05'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'CS408',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-06'),
    examType: 'Finals',
    examStartTime: '15:00',
    examEndTime: '17:00',
  },
  {
    courseCode: 'CS409',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-07'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'CS410',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-08'),
    examType: 'Finals',
    examStartTime: '14:00',
    examEndTime: '16:00',
  },
  {
    courseCode: 'CS411',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-09'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'CS412',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-10'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
  {
    courseCode: 'CS413',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-11'),
    examType: 'Finals',
    examStartTime: '09:00',
    examEndTime: '11:00',
  },
  {
    courseCode: 'CS414',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-12'),
    examType: 'Finals',
    examStartTime: '08:00',
    examEndTime: '10:00',
  },
  {
    courseCode: 'CS415',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-13'),
    examType: 'Finals',
    examStartTime: '11:00',
    examEndTime: '13:00',
  },
  {
    courseCode: 'CS416',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-14'),
    examType: 'Finals',
    examStartTime: '14:00',
    examEndTime: '16:00',
  },
  {
    courseCode: 'CS417',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-15'),
    examType: 'Finals',
    examStartTime: '10:00',
    examEndTime: '12:00',
  },
  {
    courseCode: 'CS418',
    semesterName: 'Fall 2024',
    examDate: new Date('2024-12-16'),
    examType: 'Finals',
    examStartTime: '13:00',
    examEndTime: '15:00',
  },
];

const ids = [
  'BBA101',
  'BBA102',
  'BBA201',
  'BBA202',
  'BBA301',
  'BBA302',
  'EE101',
  'EE102',
  'EE201',
  'EE202',
  'EE301',
  'EE302',
  'ME101',
  'ME102',
  'ME201',
  'ME202',
  'ME301',
  'ME302',
  'SE101',
  'SE102',
  'SE201',
  'SE202',
  'SE301',
  'SE302',
  'SE401',
  'SE402',
  'CE101',
  'CE102',
  'CE201',
  'CE202',
  'CE301',
  'CE302',
  'CE401',
  'CE402',
  'CE403',
  'CE404',
  'CS101',
  'CS102',
  'CS201',
  'CS202',
  'CS301',
  'CS302',
  'CS303',
  'CS304',
  'CS401',
  'CS402',
  'CS403',
  'CS404',
  'CS405',
  'CS406',
  'CS407',
  'CS408',
  'CS409',
  'CS410',
  'CS411',
  'CS412',
  'CS413',
  'CS414',
  'CS415',
  'CS416',
  'CS417',
  'CS418',
];

// const check = () => {
//   console.log(exams.length, ' -- ', ids.length);
//   for (let i = 0; i < ids.length; i++) {
//     let notFound = false;
//     for (let j = 0; j < exams.length; j++) {
//       if (exams[j].courseCode === ids[i]) {
//         notFound = false;
//         break;
//       } else {
//         notFound = true;
//       }
//     }
//     if (notFound) {
//       console.log(ids[i]);
//     }
//   }
// };
// check();
